<script setup lang="ts">
import ModalDescription from "./ModalDescription.vue";
import ModalHeader from "./ModalHeader.vue";
import ModalTitle from "./ModalTitle.vue";

interface ModalFallbackHeaderProps {
  /** Description adding context to the modal */
  description?: string;
  /** Title of the modal */
  title: string;
  /** ID of the title element - effectively for the aria-labelledby attribute */
  titleId?: string;
}

const { description, title, titleId } = defineProps<ModalFallbackHeaderProps>();

const emit = defineEmits<{
  /** Emitted when the close button is clicked */
  (event: "close"): void;
}>();
</script>

<template>
  <ModalHeader closeable @close="emit('close')">
    <ModalTitle :id="titleId">{{ title }}</ModalTitle>
    <ModalDescription v-if="description">{{ description }}</ModalDescription>
  </ModalHeader>
</template>
